/** Small helpers, so league-core doesn't depend on Showdown's */

type Comparable = number | string | boolean | Comparable[];

function compare(a: Comparable, b: Comparable): number {
	if (Array.isArray(a) && Array.isArray(b)) {
		for (let i = 0; i < Math.min(a.length, b.length); i++) {
			const result = compare(a[i]!, b[i]!);
			if (result) return result;
		}
		return a.length - b.length;
	}
	if (typeof a === 'string' && typeof b === 'string') return a.localeCompare(b, 'en');
	return Number(a) - Number(b);
}

/** Sorts by a key (or list of keys, compared in order); doesn't change the array it's given */
export function sortBy<T>(array: readonly T[], key: (item: T) => Comparable): T[] {
	return [...array].sort((a, b) => compare(key(a), key(b)));
}

/** "a@@@b@@@c" split at the first "@@@" into ["a", "b@@@c"] (the rest is '' if there's no delimiter) */
export function splitFirst(text: string, delimiter: string): [string, string] {
	const index = text.indexOf(delimiter);
	return index < 0 ? [text, ''] : [text.slice(0, index), text.slice(index + delimiter.length)];
}

/** "1 Tera Captain", "2 Tera Captains" */
export function count(n: number, plural: string) {
	return `${n} ${n === 1 ? plural.replace(/s$/, '') : plural}`;
}
